package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.styles.FormInputStyle
import io.horion.cv.styles.SelectFormInputStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Option
import org.jetbrains.compose.web.dom.Select
import org.w3c.dom.HTMLInputElement


@Composable
fun SelectFormField(
    label: String,
    options: List<String>,
    modifier: Modifier = Modifier,
    defaultValue: String, // Ajouter ce paramètre
    onValueChange: (String) -> Unit
) {
    var selectedValue by remember { mutableStateOf(defaultValue) }

    Column(
        modifier = modifier,
        verticalArrangement = Arrangement.spacedBy(8.px)
    ) {
        Select(
            attrs = SelectFormInputStyle.toModifier().toAttrs {
                onChange { event ->
                    val newValue = event.target.value
                    selectedValue = newValue
                    onValueChange(newValue)
                }
            }
        ) {
            options.forEach { option ->
                Option(
                    value = option,
                    attrs = {
                        if (option == selectedValue) selected()
                    }
                ) {
                    SpanText(option)
                }
            }
        }
    }
}
